import styled from 'styled-components';

export const UiFlexBox = styled.div`
	display: flex;
	padding: 0 1rem;
`;
